"use client";

import React from "react";
import { StyledSection } from "./statsStrip.styles";

export interface IStat {
  value: string;
  label: string;
}

interface IStatsStripProps {
  stats: IStat[];
}

export const StatsStrip = ({ stats }: IStatsStripProps) => {
  if (!stats.length) return null;
  return (
    <StyledSection>
      <ul className="strip">
        {stats.map((s) => (
          <li key={s.label} className="stat">
            <span className="value">{s.value}</span>
            <span className="label">{s.label}</span>
          </li>
        ))}
      </ul>
    </StyledSection>
  );
};
